// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsconfig  = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:b121a5be-1908-491c-88c9-882ef6dbcb02",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_eRV1v9xeZ",
    "aws_user_pools_web_client_id": "6pv304fntoljvh846sbkkil0f1",
    "oauth": {}
};


export default awsconfig ;
